<template>
  <div class="compressed-content">
    <h3>What is your Race / Ethnicity?</h3>
    <v-form-group class="card-selector page-buttons" :validator="$v.ethnicities">
      <b-form-checkbox-group id="ethnicities" v-model="survey.ethnicities" name="selectedEthnicities">
        <b-form-checkbox :value=ethnicityType.Hispanic>Hispanic</b-form-checkbox>
        <b-form-checkbox :value=ethnicityType.White>White Non-Hispanic</b-form-checkbox>
        <b-form-checkbox :value=ethnicityType.Black>Black Non-Hispanic</b-form-checkbox>
        <b-form-checkbox :value=ethnicityType.Native>Native American</b-form-checkbox>
        <b-form-checkbox :value=ethnicityType.SouthAsian>South Asian (India, Pakistan, Bangladesh, Nepal, Bhutan, Maldives, Sri Lanka)</b-form-checkbox>
        <b-form-checkbox :value=ethnicityType.Asian>Asian (China, Hong Kong, Taiwan, Japan, Mongolia, Korea)</b-form-checkbox>
        <b-form-checkbox :value=ethnicityType.Other>Other</b-form-checkbox>
        <b-form-checkbox :value=ethnicityType.Unknown>Adopted/Unknown</b-form-checkbox>
      </b-form-checkbox-group>
    </v-form-group>
  </div>
</template>

<script>
  import formMixin from "mixins/form-mixin";
  import { createNamespacedHelpers } from 'vuex';
  const { mapState } = createNamespacedHelpers('survey');
  import ethnicity from "enums/ethnicity";
  import { required } from "vuelidate/lib/validators";

  export default {
    mixins: [formMixin],
    data() {
      return {
        ethnicityType: ethnicity,
      };
    },

    validations: {
      ethnicities: {
        atLeastOneEthninity: required
      }
    },

    computed: {
      ...mapState(["survey"]),

      ethnicities() { return this.survey.ethnicities; }
    },
  };
</script>